function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Clean-design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pazi\\u0146ojumi",
  transform: "translate(-286, -40)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Block",
  transform: "translate(262, 24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Block-head",
  transform: "translate(24, 15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0, 1)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "viewbox",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99962308,1 C13.4973687,1 16.3328518,3.8354831 16.3328518,7.33322876 L16.3328507,8.00136179 C16.3302925,9.73057774 16.9705712,11.399015 18.1293099,12.6825722 C18.6034436,13.2077791 18.3970981,14.0457861 17.7333106,14.2907987 C16.4137711,14.7778579 15.0516514,15.1381295 13.6654205,15.3671775 C13.65497,16.50701 13.1104788,17.6046056 12.150691,18.2999015 C10.8673288,19.2296035 9.13191731,19.2296035 7.84855514,18.2999015 C6.88848696,17.6044024 6.34395802,16.5063686 6.33293109,15.3654564 C4.94002934,15.1367667 3.57930524,14.7761567 2.26489079,14.2907411 C1.60114401,14.0456182 1.39493783,13.207577 1.8691587,12.6824489 C3.02817966,11.3990078 3.66874039,9.73055769 3.66639432,7.99988236 L3.66639432,7.33322876 C3.66639432,3.8354831 6.50187742,1 9.99962308,1 Z M11.6433856,15.6058588 L11.4776811,15.618703 C10.4386491,15.6869249 9.3960703,15.6831322 8.35743264,15.607325 C8.42666012,16.027847 8.65894868,16.4173212 9.02188166,16.6802396 C9.60521812,17.1028241 10.394028,17.1028241 10.9773645,16.6802396 C11.3402975,16.4173212 11.572586,16.027847 11.6433856,15.6058588 Z M9.99962308,3 C7.60644692,3 5.66639432,4.9400526 5.66639432,7.33322876 L5.6663934,7.99852624 C5.66865692,9.6676518 5.2055246,11.2927146 4.34456055,12.6977323 L4.2523235,12.841 L4.65235683,12.95657 C5.41658148,13.1642521 6.19481601,13.3273647 6.98406628,13.4446814 L7.57893319,13.524 L8.18194859,13.5866667 C9.59291987,13.7119014 11.0136056,13.6910289 12.4213387,13.5240494 C13.4078121,13.4072512 14.3833075,13.2179905 15.340184,12.9581282 L15.7453235,12.841 L15.6539564,12.6975503 C14.8506402,11.3862165 14.3938685,9.88345549 14.3385428,8.33283776 L14.3328518,7.99988236 L14.3328518,7.33322876 C14.3328518,4.9400526 12.3927992,3 9.99962308,3 Z",
  id: "icon",
  fill: "#059DC1",
  fillRule: "nonzero"
}))))));

function SvgIcNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0392D027-A0D6-4A8E-94CA-5FC7C0FA51D4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotifications);
export default __webpack_public_path__ + "static/media/ic-notifications.407bd8fe.svg";
export { ForwardRef as ReactComponent };